export const categories = [
  {
    id: 'life',
    name: '生活',
    desc: '记录日常点滴，分享真实生活瞬间',
    icon: 'ri-leaf-line',
  },
  {
    id: 'entertainment',
    name: '娱乐',
    desc: '轻松搞笑，随时开怀的娱乐内容',
    icon: 'ri-emotion-happy-line',
  },
  {
    id: 'hobby',
    name: '兴趣',
    desc: '从手作到收藏，发现同好兴趣圈',
    icon: 'ri-palette-line',
  },
  {
    id: 'music',
    name: '音乐',
    desc: '翻唱、原创与音乐现场的精彩片段',
    icon: 'ri-music-2-line',
  },
  {
    id: 'dance',
    name: '舞蹈',
    desc: '热舞、街舞与各类舞蹈教学',
    icon: 'ri-body-scan-line',
  },
  {
    id: 'food',
    name: '美食',
    desc: '深夜厨房与城市美食探店',
    icon: 'ri-restaurant-2-line',
  },
  {
    id: 'travel',
    name: '旅行',
    desc: '城市漫游与远方风景的记录',
    icon: 'ri-roadster-line',
  },
  {
    id: 'emotion',
    name: '情感',
    desc: '都市情感观察与生活感悟分享',
    icon: 'ri-heart-3-line',
  },
] as const;

export const regions = ['内地', '港台', '日韩', '欧美', '其他'] as const;

export const durationOptions = [
  { id: 'short', name: '1 分钟以内', min: 0, max: 60 },
  { id: 'mid', name: '1 - 3 分钟', min: 60, max: 180 },
  { id: 'long', name: '3 分钟以上', min: 180, max: Number.MAX_SAFE_INTEGER },
] as const;

export const timeOptions = [
  { id: 'today', name: '今天' },
  { id: 'week', name: '本周' },
  { id: 'month', name: '本月' },
  { id: 'all', name: '全部时间' },
] as const;